import type { Capability } from './capabilities';
import { getEffectiveSurfaceCapabilities } from './effectiveSurfaceCapabilities';
import { getActiveScopedRelationships } from './scopedRelationshipResolver';
import type { User } from '@/types';

const INVESTOR_PORTAL_RELATIONSHIP_TYPES = new Set([
  'investor_representative',
  'investment_manager',
  'decision_participant',
]);

export function hasInvestorPortalRelationship(user: User | null | undefined): boolean {
  return getActiveScopedRelationships(user)
    .some((relationship) => INVESTOR_PORTAL_RELATIONSHIP_TYPES.has(relationship.type));
}

export function getInvestorPortalCapabilities(
  user: User | null | undefined,
): Capability[] {
  return hasInvestorPortalRelationship(user) ? getEffectiveSurfaceCapabilities(user) : [];
}

export function hasAnyInvestorPortalCapability(
  user: User | null | undefined,
  requiredAny: readonly Capability[],
): boolean {
  const capabilities = getInvestorPortalCapabilities(user);
  return requiredAny.some((capability) => capabilities.includes(capability));
}
